import { tempMeeApi as api, getAuthHeaders } from '~/services/api';
import { IAcceptPSATermsPayload, IAcceptPSATermsResponse } from './acceptPSATermsTypes';

const acceptPSATerms = async ({
  officeId,
}: IAcceptPSATermsPayload): Promise<IAcceptPSATermsResponse> => {
  const headers = await getAuthHeaders();

  const response = await api.post<IAcceptPSATermsResponse>(
    '/user/tos/psa',
    {},
    {
      headers: { ...headers, 'x-office': officeId ?? undefined },
    },
  );

  return response.data;
};

export const acceptPSATermsApi = {
  acceptPSATerms,
};
